import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { recruitWork } from "@/mocks/legalPages";

/** 採用ページ WORK。単一職種を上質に見せる（職種カードを並べない）。 */
export default function RecruitWork() {
  return (
    <section className="bg-background-100 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
          <Reveal>
            <div className="lg:sticky lg:top-32">
              <SectionHeading en={recruitWork.en} jp={recruitWork.heading} />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">
                {recruitWork.positionLabel}
              </span>
              <p className="mt-5 font-heading text-[24px] leading-[1.5] text-foreground-950 md:text-[30px]">
                {recruitWork.position}
              </p>

              <div className="mt-10 border-t border-foreground-950/12 pt-8 md:mt-12">
                <h3 className="text-[13px] tracking-[0.06em] text-foreground-600">仕事内容</h3>
                <ol className="mt-6 space-y-3.5">
                  {recruitWork.duties.map((duty, index) => (
                    <li
                      key={duty}
                      className="flex gap-3.5 text-[13px] leading-[2] text-foreground-800 md:text-sm"
                    >
                      <span className="shrink-0 tabular-nums text-foreground-500">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <span>{duty}</span>
                    </li>
                  ))}
                </ol>
              </div>

              <div className="mt-10 space-y-4 border-t border-foreground-950/12 pt-8">
                {recruitWork.notes.map((note) => (
                  <p key={note} className="text-[13px] leading-[2.2] text-foreground-700 md:text-sm">
                    {note}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}